import { render, staticRenderFns } from "./AdminBaseEmployers.vue?vue&type=template&id=895b110a"
import script from "./AdminBaseEmployers.vue?vue&type=script&lang=js"
export * from "./AdminBaseEmployers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports